<template>
  <div class="main">
    <h1>Computus B.V.</h1>
    <p>Computus ontwikkelt en beheert maatwerksoftware. Computus denkt met u mee, helpt u met een goede analyse van uw wensen en vertaalt deze naar een krachtige IT-oplossing. Daarbij combineert Computus jarenlange ervaring met slim gebruik van technische mogelijkheden.</p>
    <p>Computus werkt voor onder andere voor organisaties in de volgende sectoren:
      <ul>
        <li>Gezondheidszorg</li>
        <li>Onderwijs</li>
      </ul>
      Binnenkort ook voor u? Neem <router-link :to="{name: 'contact'}">contact</router-link> op! 
    </p>    
    <h3>Tijdschrijven.com</h3>
    <p>
       Computus biedt ook de applicatie <a href="https://www.tijdschrijven.com">Tijdschrijven.com</a>, de simpelste manier om tijd te registreren en te rapporteren.<br/>
       Met Tijdschrijven.com kunt u een urenregistratie bijhouden zonder dat de administratie zelf veel tijd kost. Door de start-/stopknop houdt de applicatie de tijd bij die u besteedt. U definieert zelf eenvoudig de klanten, projecten en taken waarvoor u uren wilt registreren. Met een Tijdschrijven Pro account kunt u met uw hele organisatie tijdschrijven en beschikt u over een geavanceerd hulpmiddel voor projectmanagement en projectrapportages. 
    </p>
  </div>
</template>

<script>
export default {
  name: 'Homepage',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
